import { render } from "./BalAlert.vue?vue&type=template&id=c9611bee&scoped=true&ts=true"
import script from "./BalAlert.vue?vue&type=script&lang=ts"
export * from "./BalAlert.vue?vue&type=script&lang=ts"

import "./BalAlert.vue?vue&type=style&index=0&id=c9611bee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9611bee"]])

export default __exports__